import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from '../../global/ComponentLoader/ComponentLoader';

const multiRequestImportFunc = () => {
    return import(/* webpackChunkName: "MultiRequestModal" */
    './SharedMultiRequestModalWrapper').then(mod => mod.SharedMultiRequestModalWrapper);
};

export function SharedMultiRequestModalLoader(props) {
    return <ComponentLoader {...props} load={props.load} importFunc={multiRequestImportFunc} />;
}

SharedMultiRequestModalLoader.propTypes = {
    load: PropTypes.bool.isRequired,
};
